var _a;
import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';
var initialState = {
    model: {}
};
var slice = createSlice({
    name: 'local-store',
    initialState: initialState,
    reducers: {
        setLocalStoreModel: function (state, _a) {
            var payload = _a.payload;
            state.model = _.set(state.model, payload.path, payload.model);
        },
        removeLocalStore: function (state, _a) {
            var payload = _a.payload;
            state.model = _.unset(state.model, payload.path);
        }
    },
});
export var setLocalStoreModel = (_a = slice.actions, _a.setLocalStoreModel), removeLocalStore = _a.removeLocalStore;
export default slice.reducer;
